import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-fill text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50 whitespace-nowrap">
                麻豆精品影视
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              全网最全的高清影视平台，提供海量国产精品视频在线观看、最新热门影片免费追剧，麻豆系列独家资源一站看尽。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  分类浏览
                </Link>
              </li>
              <li>
                <Link to="/articles" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  影视资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category?cat=国产剧" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  国产剧
                </Link>
              </li>
              <li>
                <Link to="/category?cat=古装剧" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  古装剧
                </Link>
              </li>
              <li>
                <Link to="/category?cat=电影" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  电影
                </Link>
              </li>
              <li>
                <Link to="/category?cat=综艺" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  综艺
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-300">
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>contact@madoujipin.com</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-xs"></i>
                </div>
                <span>010-8888-9999</span>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </div>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/50">
        <div className="px-4 md:px-6 py-5 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 麻豆精品影视网 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="/about" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="/about" className="hover:text-primary-400 transition-colors">服务条款</a>
            <a href="/about" className="hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}